import { useState } from "react";
import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";


export const useGetBackup = () => {
    const protectedAPI = useProtectedAPI()
    const [progress, setProgress] = useState(0);

    const getBackup = async (params) => {
        const queryString = objectToQueryString(params)
        const url = `/admin/backup?${queryString}`

        const response = await protectedAPI.get(url, {
            timeout: 0,
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                const percentCompleted = progressEvent.progress > 0 ? (Math.round(progressEvent.progress * 100)) : 0;
                setProgress(percentCompleted);
                if (percentCompleted === 100) {
                    setTimeout(() => setProgress(0), 1000);
                }
            },
        });
        return response.data
    }
    
    return {getBackup, progress};
}



export const useRestoreBackup = () => {
    const protectedAPI = useProtectedAPI();
    const [progress, setProgress] = useState(null);

    const restoreBackup = async (file, params) => {
        const formData = new FormData();
        formData.append("file", file);

        const queryString = objectToQueryString(params)
        const url = `/admin/restore?${queryString}`

        const response = await protectedAPI.post(url, formData, {
            timeout: 0,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = progressEvent.progress > 0 ? (Math.round(progressEvent.progress * 100)) : 0;
                setProgress(percentCompleted);
                if (percentCompleted === 100) {
                    setTimeout(() => setProgress(0), 1000);
                }
            },
        });
        return response.data
    };

    return { restoreBackup, progress };
}